import React from 'react'

export const FaqIcon = () => (
  <svg width={60} height={48} data-testid="FaqIcon">
    <g fill="none" fillRule="evenodd" transform="translate(2)">
      <circle cx="23.642" cy="24.167" r="21.642" fill="#F9DFDF" />
      <g stroke="gray" strokeLinecap="round" strokeWidth={2}>
        <path
          strokeLinejoin="round"
          d="M4 29.76L.221 27.015a2 2 0 1 1 2.351-3.236L4 24.816V15a2 2 0 1 1 4 0v3-6a2 2 0 1 1 4 0v6-3a2 2 0 1 1 4 0v4.5V18a2 2 0 1 1 4 0v13a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-1.24z"
        />
        <path fill="#D8D8D8" d="M8 15v8.194M12 15v8.194M16 15v8.194" />
        <path d="M12.5 31.5A4.5 4.5 0 0 0 8 27" />
      </g>
      <g stroke="gray" strokeLinecap="round" strokeWidth={2}>
        <path
          strokeLinejoin="round"
          d="M28 37.76l-3.779-2.745a2 2 0 1 1 2.351-3.236L28 32.816V23a2 2 0 1 1 4 0v3-6a2 2 0 1 1 4 0v6-3a2 2 0 1 1 4 0v4.5V26a2 2 0 1 1 4 0v13a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4v-1.24z"
        />
        <path fill="#D8D8D8" d="M32 23v8.194M36 23v8.194M40 23v8.194" />
        <path d="M36.5 39.5A4.5 4.5 0 0 0 32 35" />
      </g>
      <path stroke="gray" strokeWidth={2} d="M8 48V35h8v13m16 0v-5h8v5" />
      <g transform="translate(36)">
        <circle cx={9} cy={9} r={9} fill="#C00" />
        <g fill="#FFF" fillRule="nonzero" transform="translate(6 4)">
          <circle cx={3} cy={9} r={1} />
          <path d="M2.164 2.5c.197-.3.492-.5.885-.5.59 0 .984.4.984 1 0 .3-.099.4-.59.7-.59.4-1.377 1-1.377 2.3v1h1.967V6c0-.2 0-.3.492-.6C5.115 5 6 4.4 6 3c0-1.7-1.279-3-2.95-3C1.966 0 .983.6.491 1.5L0 2.4l1.672 1 .492-.9z" />
        </g>
      </g>
    </g>
  </svg>
)
